import * as React from "react";
import { connect } from "react-redux";


class OnboardingSidebar extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        const { title, imageUrl, subHeading } = this.props;        
        return (
            <>               
                <div className="row align-items-lg-center">                   
                    <div className="col-12">
                        <img alt="MyBSWHealth" className="img-fluid d-none d-lg-block" src={`/images/${imageUrl}`} />
                        <div className="image-title">{title}</div>
                        <div className="image-subheading"> {subHeading}</div>
                        {this.props.children}
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {

    };
};
const mapDispatchToProps = (dispatch) => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingSidebar);

